import React from 'react';
import './App.css';
// import HeroSection from './components/Hero';
// import ServicesSection from './components/Services';
// import AboutSection from './components/About';
// import RealisationsSection from './components/Realisations';
// import Footer from './components/Footer';
// import Navbar from './components/Navbar';
// import ContactSection from './components/Contact';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Index from './pages/Index';

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<Index />} />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  )

  // return (
  //   <>
  //     <Helmet>
  //       <link rel="canonical" href="https://bartkiewiczmeble.pl" />
  //     </Helmet>
      
  //     <div className='min-h-screen bg-background dark'>
  //       <Navbar />
  //       <HeroSection />
  //       <AboutSection />
  //       <ServicesSection />
  //       <RealisationsSection />
  //       <ContactSection />
  //       <Footer />
  //     </div>
  //   </>
  // );
}

export default App;
